export default __webpack_public_path__ + "static/media/ic_insert_invitation_48px.d2086331.svg";